import React from 'react';
import ContentRenderer from './ContentRenderer';
import { DisplayItem } from '../../types/lesson';

interface DisplayContentProps {
  displayItems: DisplayItem[];
  className?: string;
}

const DisplayContent: React.FC<DisplayContentProps> = ({ displayItems, className = '' }) => {
  if (!displayItems || displayItems.length === 0) {
    return null;
  }

  return (
    <div className={`display-content ${className}`}>
      {displayItems.map((item, index) => (
        <ContentRenderer 
          key={index} 
          item={item}
          className="mb-4"
        />
      ))}
    </div>
  );
};

export default DisplayContent;